<div class="custom-domain-requests-container">
    <div class="header-row">
        <h4 class="mb-0">Custom Domain Requests</h4>
        <mat-form-field appearance="outline" class="search-field">
            <mat-label>Search by company, domain or status</mat-label>
            <input
                id="custom-domain-requests-search"
                matInput
                [ngModel]="searchTerm"
                (ngModelChange)="applySearch($event)"
                placeholder="Search"
            />
            <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
    </div>

    @if (loading) {
        <div class="loading-state">
            <mat-spinner diameter="32"></mat-spinner>
        </div>
    } @else {
        <div class="table-wrapper">
            <table
                mat-table
                [dataSource]="dataSource"
                matSort
                class="mat-elevation-z2"
                id="custom-domain-requests-table"
            >
                <ng-container matColumnDef="orgName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Company/App Name</th>
                    <td mat-cell *matCellDef="let row" class="p-1">{{ row.orgName }}</td>
                </ng-container>

                <ng-container matColumnDef="requestedDomain">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Requested Domain</th>
                    <td mat-cell *matCellDef="let row" class="p-1">{{ row.requestedDomain || 'N/A' }}</td>
                </ng-container>

                <ng-container matColumnDef="domainType">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Domain Type</th>
                    <td mat-cell *matCellDef="let row" class="p-1">
                        <span class="domain-type-chip" [class.custom-domain]="row.domainType === 'custom-domain'">
                            {{ row.domainType }}
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="staticWebAppName">
                    <th mat-header-cell *matHeaderCellDef>Azure SWA Name</th>
                    <td mat-cell *matCellDef="let row" class="p-1">{{ row.staticWebAppName || 'TBD' }}</td>
                </ng-container>

                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                    <td mat-cell *matCellDef="let row" class="p-2">
                        <mat-form-field appearance="outline" class="status-field">
                            <mat-select
                                id="status-select-{{ row.requestId }}"
                                [value]="row.status"
                                (selectionChange)="updateStatus(row, $event)"
                                class="status-selector"
                                panelClass="custom-domain-requests-status-panel"
                            >
                                @for (option of statusOptions; track option.value) {
                                    <mat-option [value]="option.value">{{ option.label }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </td>
                </ng-container>

                <ng-container matColumnDef="createdAt">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Created</th>
                    <td mat-cell *matCellDef="let row" class="p-1">
                        {{
                            row.createdAt && row.createdAt.toDate
                                ? (row.createdAt.toDate() | date: 'short')
                                : (row.createdAt | date: 'short')
                        }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="updatedAt">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Updated</th>
                    <td mat-cell *matCellDef="let row" class="p-1">
                        {{
                            row.updatedAt && row.updatedAt.toDate
                                ? (row.updatedAt.toDate() | date: 'short')
                                : (row.updatedAt | date: 'short')
                        }}
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
        </div>
    }
</div>
